enum SyncType {
  STANDARD = "standard",
  POST_SYNC = "post-sync",
  PRE_SYNC = "pre-sync",
}

export default SyncType;
